import React, { useEffect } from "react";

import GreyTable from '../../../../components/Tables/GreyTable';
import { InwDatetail, resetInwDetail } from '../../../../Redux/Slice/Grey/PartyProfile/PartyProfileSlice';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const InwardDetail = ({ selectedProduction, selectedAccount }) => {

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  const dispatch = useDispatch();

  const { InwDatetailData } = useSelector((state) => state.PartyProfileSlice);

  useEffect(() => {
    dispatch(resetInwDetail())
    dispatch(InwDatetail({ selectedIds: selectedProduction ? selectedProduction.toString() : "", PARTYWISEIds: selectedAccount ? selectedAccount.toString() : "" }));
  }, [selectedProduction, selectedAccount]);

  const columns = [
    { key: "srNumber", label: "Sr. No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "InwardDate", label: "InwardDate", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "ChallanNo", label: "Challan No", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "PartyMarka", label: "Party Marka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "lotno", label: "LotNo", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: true },
    { key: "acname", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "TotalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "TotalMeter", label: "Total Meter", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  const columnFields = ["ChallanNo", "lotno", "TotalTaka", "TotalMeter"];

  const formattedRows = InwDatetailData?.InwDate?.map((row, index, arr) => {
    const totalLength = arr.length.toString().length;

    const formattedRow = {
      id: index,
      // srNumber: (index + 1).toString().padStart(totalLength, "0"),
      ...row,
      InwardDate: new Date(row.InwardDate).toLocaleDateString("en-GB"),
    };

    columnFields.forEach((field) => {
      if (field === "TotalMeter") {
        formattedRow[field] = row[field];
      } else {
        formattedRow[field] = row[field];
      }
    });

    return formattedRow;
  });

  if (InwDatetailData === null) {

    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <div>
      <Row>
        <Col>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                color:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour8,
                padding: "14px",
              }}
            >
              <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px" , fontWeight:"700" }}>
                INWARD DETAIL
              </h2>
            </div>
            <div><GreyTable columns={columns} data={formattedRows} iscolourDark={iscolourDark}
              iscolour={iscolour} /></div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
